import { DialogRef } from '@angular/cdk/dialog';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-view-edit-common',
  templateUrl: './view-edit-common.component.html',
  styleUrls: ['./view-edit-common.component.css']
})
export class ViewEditCommonComponent {
  rowData: any;
  columns: any[];
  triggeredColumn:any;
  printData: boolean = false;
  ngOnInit(): void {
    
  }

  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.rowData = this.config.data.rowData;
    this.columns = this.config.data.columns;
    this.triggeredColumn = this.config.data.triggeredColumn;
    console.log('Row Data:', this.rowData);  // Verify the row data
    console.log('Columns:', this.columns);   // Verify the columns
    console.log('Columns key:', this.triggeredColumn);   // Verify the columns
  }

  closeDialog() {
    this.ref.close();
  }

  getColumnPairs(columns: any[]): any[][] {
    const pairs = [];
    for (let i = 0; i < columns.length; i += 2) {
      pairs.push([columns[i], columns[i + 1]]);
    }
    return pairs;
  }
  
}
